"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setTermsAndConditionsCookie = void 0;
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _constants = require("../constants");
const setTermsAndConditionsCookie = customerId => _jsCookie.default.set(_constants.termsAndConditionsCookieName, customerId.toString(), {
  path: '/'
});
exports.setTermsAndConditionsCookie = setTermsAndConditionsCookie;
